export default __webpack_public_path__ + "static/prohelvetia-4ba716ce8ba29721a5d0f1637c318d3c.png";